import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Typography, Box, Chip, Grid, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Divider } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

import ShowProformaInvoice from "components/product/components/price-calculation/ShowProformaInvoice";
import RemarkListPage from "components/remark/page/RemarkListPage";
import { setEditOrderStory } from "store/slice/AppSlice";
import { submitOrderForApprovalAPI } from "api/OrderServicesExtn";
import { updatePharmaorderObj } from "store/slice/PharmaSlice";
import { use } from "react";

export default function OrderReview() {
  const dispatch = useDispatch()
  const { remarkList } = useSelector((state) => state.pharmaslice.remarkDashboard);
  const { pharmaorderObj } = useSelector((state) => state.pharmaslice.pharmaorderDashboard);
  const [errMsg, setErrMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [apiInProgress, setApiInProgress] = useState(false);
  const rolename = useSelector((state) => state.headerslice.userprofileInfo);
  
  useEffect(() => {
  }, [remarkList]);

  const goToProductList = () => {
    dispatch(setEditOrderStory({ // Initialize the add order story state
      title: "Manage Product(s)",
      description: "Manage Product(s)",
      currentState: "ORDER_DASHBOARD",
    }));
  }
  const handleOrderSubmit = () => {
    setErrMsg('')
    setApiInProgress(true);

    submitOrderForApprovalAPI({
      orderId: pharmaorderObj.id
    }, (response) => {
      dispatch(updatePharmaorderObj(response.pharmaorderInfo));
      setSuccessMsg("Order '" + response.pharmaorderInfo.id + "' is submitted for approval !!!");
    },
      (apiErrMsg) => {
        setApiInProgress(false);
        setErrMsg(apiErrMsg);
      }
    )
  }
  return (
    <>
      <Grid
        container
        direction="row"
        sx={{ width: '100%', backgroundColor: 'secondary.lighter', height: '80vh' }}
      >
        <Grid item xs={12} lg={9}>
          <ShowProformaInvoice />
        </Grid>
        <Grid
          item
          xs={12}
          lg={3}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            backgroundColor: 'white',
            padding: 1,
          }}
        >
          {/* Remarks Section */}
          {/* <Box sx={{ flexShrink: 0, backgroundColor: 'secondary.lighter', p: 1, mb: 1 }}>
            <RemarkListPage maxHeight="50vh"/>
          </Box> */}
          {/* Spacer to push buttons to the bottom */}
          <Box sx={{ flexGrow: 1 }} />
          {/* Success Message */}
          {successMsg && (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                py: 4,
                px: 2,
                mb: 2,
                backgroundColor: '#e8f5e9',
                borderRadius: 2,
                boxShadow: 2,
              }}
            >
              <CheckCircleOutlineIcon sx={{ fontSize: 60, color: 'success.main', mb: 1 }} />
              <Typography variant="h6" color="success.main" sx={{ fontWeight: 600, mb: 1 }}>
                Success!
              </Typography>
              <Typography variant="body1" color="text.secondary" align="center">
                {successMsg}
              </Typography>
            </Box>
          )}
          {/* Button Container */}
          {!successMsg && (
            <Box sx={{ width: '100%', pt: 1, pb: 1 }}>
              <Divider sx={{ mb: 2 }} />
              {errMsg && (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" color="error" align="center">
                    {errMsg}
                  </Typography>
                </Box>
              )}
              <Grid container direction="row" justifyContent="flex-end" spacing={2}>
                <Grid item>
                  <Button
                    variant="outlined"
                    startIcon={<ArrowBackIcon />}
                    onClick={goToProductList}
                  >
                    Product List
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    endIcon={<ArrowForwardIcon />}
                    onClick={handleOrderSubmit}
                    disabled={apiInProgress}
                  >
                    Submit for Approval
                  </Button>
                </Grid>
              </Grid>
            </Box>
          )}
        </Grid>
      </Grid>
    </>
  );
}